<app-landingpage-header-child></app-landingpage-header-child>

<div class="container mt-4 mb-4 content-main">
    <div class="content-main-box">
        <h4 class="font-weight-bold">{{"rules_payment.rules_and_form_of_payment" | translate}}</h4>
        <hr>

        <p class="font-weight-bold">
            {{"rules_payment.rules_and_form_of_payment_info" | translate}}
        </p>

        <p class="font-weight-bold">{{"rules_payment.rules_and_form_of_payment_1" | translate}}</p>

        <p>
            {{"rules_payment.rules_and_form_of_payment_contents.modal_content_1" | translate}}
        </p>

        <p>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_2" | translate}} <span class="font-weight-bold">{{"rules_payment.rules_and_form_of_payment_contents.modal_content_7" | translate}}</span>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_3" | translate}}</p>

        <p class="font-weight-bold">{{"rules_payment.rules_and_form_of_payment_2" | translate}}</p>

        <p>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_4" | translate}}</p>

        <p>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_5" | translate}}</p>

        <ul class="text-height-2">
            <li>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_6" | translate}} <span class="font-weight-bold">{{"rules_payment.rules_and_form_of_payment_contents.modal_content_7" | translate}}</span> 
                {{"rules_payment.rules_and_form_of_payment_contents.modal_content_8" | translate}}</li>
            <li>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_9" | translate}}</li>
            <li>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_10" | translate}}</li>
            <li>{{"rules_payment.rules_and_form_of_payment_contents.modal_content_11" | translate}}</li>
        </ul>

        <p>
            {{"rules_payment.rules_and_form_of_payment_contents.modal_content_12" | translate}}
        </p>
    </div>
</div>

<app-landingpage-footer></app-landingpage-footer>